import { API, authClient } from "../index";

export const getRatings = (params) => {
	return authClient().get(`${API}/rating${params ? params : ""}`);
};
